/*
 * MDB shim for TabContent
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Reports/reports.jsx
 */

import MUIBox from "@mui/material/Box";

export default function TabContent({ children, ...rest }) {
    return <MUIBox
    sx={{
        padding: "20px",
        
    }}
    {...rest}>{children}</MUIBox>;
}
